import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
    },
    body: {},
    bodyInner: {},
    title: {
      textTransform: 'capitalize',
      paddingLeft: 64,
    },
    group: {},
    heading: {
      textTransform: 'capitalize',
    },
    card: {},
    listing: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    calendarImg: {
      display: 'block',
    },
    monthGroup: {},
    monthList: {
      display: 'flex',
    },
    monthItem: {
      flexGrow: 1,
      backgroundColor: theme.colors.neutral[0],
      height: 52,
      borderRadius: 0,
      paddingLeft: 4,
      paddingRight: 4,
      '.text': { color: theme.colors.neutral[5], textTransform: 'capitalize' },
      '&,&:active': {
        border: `1px solid ${theme.colors.neutral[1]}`,
        borderTop: 0,
      },
      '&[data-active]': {
        '&,&:active': {
          backgroundColor: '#FFF5DC',
          borderLeftColor: '#FFE299',
          borderBottomColor: '#FFE299',
          borderRightColor: theme.colors.neutral[1],
          '.text': { color: '#262626' },
        },
      },
    },
  }
})
